import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal } from "@/components/shared/Reveal";
import { Cable, Info } from "lucide-react";

export const ELDIntegration = () => (
  <section id="eld" data-testid="eld-integration-section" className="py-20 md:py-28 bg-rr-surface">
    <div className="max-w-5xl mx-auto px-5 md:px-8 grid lg:grid-cols-[auto_1fr] gap-10 items-center">
      <Reveal>
        <div className="w-16 h-16 rounded-2xl bg-rr-navy flex items-center justify-center text-white">
          <Cable size={28} />
        </div>
      </Reveal>

      <div>
        <SectionHeading
          eyebrow="Hours of Service"
          title="Connect the ELD You Already Use"
          description="RelayRigs is being designed to connect with supported ELD providers so applicable, authorized HOS information can help with assignment and relief workflows."
          testId="eld-integration"
        />
        <Reveal delay={0.15}>
          <div data-testid="eld-disclaimer" className="mt-6 flex items-start gap-2.5 text-xs text-rr-muted bg-white border border-rr-line rounded-lg px-4 py-3 max-w-xl">
            <Info size={14} className="text-rr-orange shrink-0 mt-0.5" />
            Not every ELD provider is supported, and this is not a DOT compliance certification.
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
